"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveResponsiveProp = exports.default = void 0;
var _systemConstants = require("@telus-uds/system-constants");
var _ViewportProvider = require("../ViewportProvider");
var _hasOwnProperty = _interopRequireDefault(require("./hasOwnProperty"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const hasResponsiveProperties = objectProp => _systemConstants.viewports.keys.some(key => (0, _hasOwnProperty.default)(objectProp, key));

/**
 * Resolves a prop which may be a responsive object with keys for viewports.
 *
 * Used internally in useResponsiveProp - see that for more details.
 *
 * @param {*} prop
 * @param {"xs"|"sm"|"md"|"lg"|"xl"} viewport
 * @param {*} [defaultValue]
 * @returns {*}
 */
const resolveResponsiveProp = (prop, viewport, defaultValue) => {
  if (prop === undefined) return defaultValue;
  if (!prop || typeof prop !== 'object' || !hasResponsiveProperties(prop)) return prop;
  const value = _systemConstants.viewports.keys.includes(viewport) ?
  // If there's a current viewport, return the closest match at or below it
  _systemConstants.viewports.inherit(prop)[viewport] :
  // If no current viewport is available, default to smallest viewport
  prop[_systemConstants.viewports.keys.find(key => (0, _hasOwnProperty.default)(prop, key))];
  return value === undefined || value === null ? defaultValue : value;
};

/**
 * Takes any value and, if that value is a responsive prop (an object with one or more
 * keys matching system viewport names), returns the value corresponding to the largest
 * viewport key smaller than the current screen's viewport.
 *
 * For example, if passed `{ sm: 4, lg: 8 }`, it will return 8 on `xl` and `lg` viewports,
 * 4 on `md` and `sm` viewports, and `undefined` (or a provided `defaultValue`) on `xs` viewports.
 *
 * To generate propTypes for responsive props, see `responsiveProps` in `./utils/props/responsiveProps.js`.
 *
 * @param {*} prop - any value which may be an object with viewport keys
 * @param {*} [defaultValue] - default value to provide if no matches found for the current viewport
 * @returns {*}
 */
exports.resolveResponsiveProp = resolveResponsiveProp;
const useResponsiveProp = (prop, defaultValue) => {
  const viewport = (0, _ViewportProvider.useViewport)();
  return resolveResponsiveProp(prop, viewport, defaultValue);
};
var _default = exports.default = useResponsiveProp;